// extracted by mini-css-extract-plugin
module.exports = {"title":"Scheduler-module__title__3JTlF","data":"Scheduler-module__data__Ygf-5"};